import { Container } from "react-bootstrap";

import "./ts-cs.scss";
import { TermsConditionsData } from "./ts-cs-data";
import React from "react";

export const TermsAndConditions = () => {

 
   

    
  return (
    <section>
      <Container className="px-3">
        <div className="ts-cs-content mt-5">
          <span className=" fw-bold ">[Last Updated 12th December 2024]</span>
          <p className="fs-2 fw-bold  privacy-title">Introduction</p>
          <p className="ts-cs-description fs-6 ">
          These Terms and Conditions (“Terms”) together with all policies and additional terms posted on and in our sites, applications, tools, and services (collectively "Services") set out the terms on which Pamo Services Ltd (“Company”, “We”, “Our”, “Us”) offers you access to and use of Our Services. These Terms apply to and are enforceable against anyone who accesses our services through this website or our applications. These Terms shall apply to both merchants and buyers(“Users”). 
          </p>
        </div>

        <div className="mb-5">
          {TermsConditionsData.map((data, key) => (
            <ul key={key}>
              <div className="fs-5 fw-bold mt-5 ts-cs-items">
                {data.listName}
              </div>
              <div className="fw-semibold">
                {data?.sub}
              </div>
              {data.list.map((data, key) => (
                <li className="my-2 ts-cs-items">{data.item}</li>
              ))}
            </ul>
          ))}
             
        </div>
      </Container>
    </section>
  );
};
